<div class="main-container" data-cy="patient-portal-pay-now-dialog-main-container">
  <div class="main-title" data-cy="patient-portal-pay-now-dialog-title-text">
    Pay Now
  </div>

  <div class="sub-title" data-cy="patient-portal-pay-now-dialog-patient-name-label">
    {{ patientName }}
  </div>

  @if (!isAuthorised && errorMessage) {
    <div style="margin-top: 12px; padding: 12px; border-radius: 6px; background: #ffebee; color: #b71c1c;" data-cy="patient-portal-pay-now-dialog-error-container">
      <div style="font-weight: 600;" data-cy="patient-portal-pay-now-dialog-error-title-text">Payment not accepted</div>
      <div data-cy="patient-portal-pay-now-dialog-error-message-text">{{ errorMessage }}</div>
    </div>
  }

  @if (isAuthorised) {
    <div style="margin-top: 12px; padding: 12px; border-radius: 6px; background: #e8f5e9; color: #1b5e20;" data-cy="patient-portal-pay-now-dialog-success-container">
      <div style="font-weight: 600;" data-cy="patient-portal-pay-now-dialog-success-title-text">Payment Accepted</div>
      <div data-cy="patient-portal-pay-now-dialog-success-message-text">{{ authorisedMessage }}</div>
      @if (surchargeAmount > 0) {
        <div data-cy="patient-portal-pay-now-dialog-surcharge-text">A {{ surchargeAmount | currency }} credit card surcharge was included in the amount charged to your card.</div>
      }
      <div style="margin-top: 8px;" data-cy="patient-portal-pay-now-dialog-success-instruction-text">Please click <b>Close</b> to continue.</div>
    </div>
  }

  <div class="amount-container" data-cy="patient-portal-pay-now-dialog-amount-container">
    @if (!isAuthorised) {
      <div class="amount-label" data-cy="patient-portal-pay-now-dialog-amount-label">
        Amount to pay (total due: {{ totalDue | currency }})
      </div>
    }

    @if (!isAuthorised) {
      <mat-form-field appearance="fill" class="amount-input" data-cy="patient-portal-pay-now-dialog-amount-form-field">
        <input
          matInput
          type="text"
          inputmode="decimal"
          [(ngModel)]="amountText"
          (keypress)="onAmountKeypress($event)"
          (focus)="onAmountFocus()"
          (blur)="onAmountBlur()"
          [disabled]="isPaying || isAuthorised"
          data-cy="patient-portal-pay-now-dialog-amount-input"
          />
        </mat-form-field>
        @if (isAmountEmpty) {
          <div style="color: red;" data-cy="patient-portal-pay-now-dialog-amount-required-error-text">Amount is required</div>
        }
        @if (isAmountBelowMinimum) {
          <div style="color: red;" data-cy="patient-portal-pay-now-dialog-amount-minimum-error-text">Minimum payment is $0.01</div>
        }
        @if (isAmountExceedsTotalDue) {
          <div style="color: red;" data-cy="patient-portal-pay-now-dialog-amount-maximum-error-text">Cannot exceed {{ totalDue | currency }}</div>
        }
      } @else {
        <div class="amount-label" data-cy="patient-portal-pay-now-dialog-paid-summary-label">
          Paid: <b data-cy="patient-portal-pay-now-dialog-paid-amount-label">{{ amountToPay | currency }}</b> <br/>
          @if (surchargeAmount > 0) {
            Credit Card Surcharge: <b data-cy="patient-portal-pay-now-dialog-surcharge-amount-label">{{ surchargeAmount | currency }}</b> <br/>
            Total Charged to Card: <b data-cy="patient-portal-pay-now-dialog-total-charged-label">{{ amountToPay + surchargeAmount | currency }}</b> <br/>
          }
          Remaining Balance: <b data-cy="patient-portal-pay-now-dialog-remaining-balance-label">{{ totalDue | currency }}</b>
        </div>
      }

    </div>

    <div class="action-container" data-cy="patient-portal-pay-now-dialog-action-container">
      <button mat-button data-cy="pay-now-dialog-close-btn" class="tdo-close" color="warn" (click)="close()" [disabled]="isPaying">Close</button>
      <button mat-raised-button data-cy="pay-now-dialog-btn" class="pay-now-button" color="primary" (click)="payNow()" [disabled]="isPaying || isAuthorised || isPaymentInvalid">
        @if (!isPaying) {
          <span data-cy="patient-portal-pay-now-dialog-pay-now-button-text">Pay Now</span>
        }
        @if (isPaying) {
          <mat-spinner class="pay-now-spinner" [diameter]="18" data-cy="patient-portal-pay-now-dialog-pay-now-spinner"></mat-spinner>
        }
      </button>
    </div>
  </div>

